import { StudentSkillStates } from '../models/StudentSkillState';
import { mapSkillStatus } from './mapSkillStatus';
import { SkillStatesLabel } from '../models/SkillState';

/**
 * Utility function to check if a skill is completed - aligned with progress bar logic
 * Uses the same mapSkillStatus function that the progress bar uses
 */
export const isSkillCompleted = (skill: StudentSkillStates): boolean => {
  const { status } = mapSkillStatus(skill.skillSubstate?.id, skill.skillAssessment?.score);

  // Skills are considered completed if they are "Passed" or "Placed Out"
  // This matches the logic used in progressBarDashboard function
  return status === SkillStatesLabel.PASSED || status === SkillStatesLabel.PLACED_OUT;
};

/**
 * A unit is complete when it has no incomplete `Target`-type checkpoint skill.
 * This mirrors the incomplete-unit test useDefaultUnit uses, so the two never
 * disagree. A unit with zero checkpoint skills counts as complete (nothing left).
 */
export const isUnitComplete = (studentSkillStates: StudentSkillStates[], unitId: string): boolean => {
  const unitCheckpointSkills = studentSkillStates.filter(
    skill =>
      skill.skill?.targetSkills?.some(
        targetSkill => targetSkill.target?.id === unitId && targetSkill.targetSkillType.name === 'Target',
      ),
  );

  return !unitCheckpointSkills.some(skill => !isSkillCompleted(skill));
};
